import PropTypes from 'prop-types'
import { useFormContext, Controller } from 'react-hook-form'
import { MobileDateTimePicker } from '@mui/x-date-pickers'

RHFDateTimePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.node,
  InputProps: PropTypes.object,
  fullWidth: PropTypes.bool,
  disableFuture : PropTypes.bool,
  disablePast : PropTypes.bool
}

export default function RHFDateTimePicker({ 
    name, label, disableFuture = false, disablePast = false, 
    InputProps, fullWidth, ...other 
}) {

    const { control, setValue } = useFormContext()

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <MobileDateTimePicker
                    sx={{ width : '100%', marginTop : 0, marginBottom : 0}}
                    {...field}
                    label={label}
                    value={field?.value || null}
                    onChange={(newTime) => setValue(name, newTime , { shouldValidate: true })}
                    slotProps={{
                        textField: {
                            fullWidth,
                            helperText: error?.message,
                            error: !!error,
                            margin: 'dense',
                            InputProps
                        },
                    }}
                    disablePast={disablePast}
                    disableFuture={disableFuture}
                    {...other}
                />
            )}
        />
    )
}